<template>
  <li class="tree-item">
    <div
      class="tree-item-content"
      @mouseover="showActions"
      @mouseleave="hideActions"
      @click="toggle"
    >
      <span v-if="hasChildren" @click="toggle" class="toggle-icon">
        <img v-if="isOpen" src="@/images/next_n.png" alt="Collapse" style="width: 10px;" />
        <img v-else src="@/images/prev_n.png" alt="Expand" style="width: 10px;" />
      </span>
      <span v-if="!isEditing" >{{ department.deptName }}</span>

      <div class="tree-item-actions" :class="{ show: actionsVisible }">
        <img
          v-if="department.type === 'D' || department.type === 'W'"          
          @click="showHideNewDeptPopup(true)"
          src="@/images/add.png"
          class="tree-icon"
          alt="Add"
        />
        <img
          v-if="department.type === 'D'"
          @click="editItem()"
          src="@/images/edit.png"
          class="tree-icon"
          alt="Edit"
        />
        <img
          v-if="department.type === 'D'"
          @click="deleteItem"
          src="@/images/minus.png"
          class="tree-icon"
          alt="Delete"
        />
      </div>
    </div>
    <ul v-if="isOpen && hasChildren" class="tree-children">
      <tree-item
        v-for="child in department.children"
        :key="child.deptId"
        :department="child"
        @select="$emit('select', $event)"
        @add-child="$emit('add-child', $event)"
        @edit-department="$emit('edit-department', $event)"
        @delete-department="$emit('delete-department', $event)"
      ></tree-item>
    </ul>
    <!-- 소속 추가 modal -->
    <div v-if="showNewDeptPopup.value" class="d_pop1">
      <div class="d_pop_box">
        <div class="d_pop_top">
          <div class="title">소속 추가</div>
          <a href="###" @click="showHideNewDeptPopup(false)">⨉</a>
        </div>
        <div class="d_pop_middle">
          <div class="tbl_search">
            <table>
              <colgroup>
                <col style="width: 30%" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th>상위소속명</th>
                  <td>                  
                    <div class="inner_td">
                      <span class="pop_text">{{ parentDepartName }}</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>소속명</th>
                  <td>                  
                    <div class="inner_td">
                      <input
                          type="text"
                          class="pop_text"
                          v-model="newDepartName"
                          placeholder="소속명을 입력해주세요."
                          @keyup.enter="handleSearchKeyEnter"
                        />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>소속선택 가능여부</th>
                  <td>                  
                    <div class="inner_td">
                      <button type="button" :class="{ on: selectableYn === 'Y'}" @click="selectSelectableYn('Y')" >선택가능</button>
                      <button type="button" :class="{ on: selectableYn === 'N'}" @click="selectSelectableYn('N')" >선택불가</button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>        
          <div class="btn_bottom_a">
            <a href="###" class="on" @click="addItem">등록</a>
            <a href="###" @click="showHideNewDeptPopup(hide)">취소</a>
          </div>
        </div>
      </div>
    </div>
    <!-- 소속 추가 modal -->
    <!-- 소속 수정 modal -->
    <div v-if="showEditDeptPopup.value" class="d_pop1">
      <div class="d_pop_box">
        <div class="d_pop_top">
          <div class="title">소속 수정</div>
          <a href="###" @click="showHideEditDeptPopup(false)">⨉</a>
        </div>
        <div class="d_pop_middle">
          <div class="tbl_search">
            <table>
              <colgroup>
                <col style="width: 30%" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th>상위소속명</th>
                  <td>                  
                    <div class="inner_td">
                      <span class="pop_text">{{ parentDepartName }}</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>소속명</th>
                  <td>                  
                    <div class="inner_td">
                      <input
                          type="text"
                          class="pop_text"
                          v-model="editDepartName"
                          placeholder="소속명을 입력해주세요."
                          @keyup.enter="handleSearchKeyEnter"
                        />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>소속선택 가능여부</th>
                  <td>                  
                    <div class="inner_td">
                      <button type="button" :class="{ on: selectableYn === 'Y'}" @click="selectSelectableYn('Y')" >선택가능</button>
                      <button type="button" :class="{ on: selectableYn === 'N'}" @click="selectSelectableYn('N')" >선택불가</button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>        
          <div class="btn_bottom_a">
            <a href="###" class="on" @click="saveEdit">저장</a>
            <a href="###" @click="showHideEditDeptPopup(hide)">취소</a>
          </div>
        </div>
      </div>
    </div>
    <!-- 소속 수정 modal -->
  </li>
</template>

<script>
import { ref, nextTick, computed } from 'vue';
import apiClient from '@/apiClient';

export default {
  props: {
    department: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    console.log(JSON.stringify(props.department));
    const isEditing = ref(false);
    const editName = ref(props.department.deptName);
    const isOpen = ref(false);
    const actionsVisible = ref(false);
    const parentDepartName = computed(() => {
      const { parentDeptId, departPath, deptName } = props.department;

      if (parentDeptId === 0) {
        return departPath.split(" → ")[0];
      } else {
        const pathParts = departPath.split(" → ");
        if (pathParts.length > 1 && pathParts[pathParts.length - 1] === deptName) {
          pathParts.pop();
        }
        return pathParts.join(" → ");
      }
    });

    const newDepartName = ref('');
    const selectableYn = ref('');
    const editDepartName = ref('');
    const showNewDeptPopup = ref({ value: false });
    const showEditDeptPopup = ref({ value: false });


    const hasChildren = computed(() => props.department.children && props.department.children.length > 0);

    const selectDepartment = () => {
      emit('select', props.department);
    };

    const toggle = () => {
      isOpen.value = !isOpen.value;
      selectDepartment();
    };

    const showHideNewDeptPopup = (val) => {
      showNewDeptPopup.value = { value: val };      
      newDepartName.value = '';
      selectableYn.value = false;
    }

    const showHideEditDeptPopup = (val) => {
      showEditDeptPopup.value = { value: val };   
      isEditing.value = false;
    }

    const editItem = () => {
      showHideEditDeptPopup(true);
      isEditing.value = true;
      editDepartName.value = props.department.deptName;
      selectableYn.value = props.department.selectableYn;
      nextTick(() => {
        const input = document.querySelector('input');
        if (input) input.focus();
      });
    };
    
    const saveEdit = async () => {
      try {
        const response = await apiClient.post("/api/Department/depart-edit", {
          DeptId: props.department.deptId,
          DeptName: editDepartName.value.trim(),
          SelectableYn: selectableYn.value,
          LoginUserId: localStorage.getItem("userid"),
        });

        if (response.status === 200) {
          emit('edit-department', { deptId: props.department.deptId, deptName: editDepartName.value.trim(), selectableYn: selectableYn.value });
          isOpen.value = true;
        }
      } catch (error) {
        console.error(`Error Dept Edit: ${error}`);
      }

      isEditing.value = false;
      showHideEditDeptPopup(false);
    };

    const addItem = async () => {      
      try {
        const response = await apiClient.post("/api/Department/depart-add", {
          DeptName: newDepartName.value,
          ParentDeptId: props.department.deptId ?? 0,
          DeptCompanyId: props.department.deptCompanyId,
          SelectableYn: selectableYn.value,
          Level: props.department.level,
          Type: props.department.type,
          LoginUserId: localStorage.getItem("userid"),
        });

        if (response.status === 200) {
          const returnData = response.data;

          const newDepartment = {
            deptId: returnData.department.DeptId,
            deptName: newDepartName.value,
            parentDeptId: returnData.department.ParentDeptId,
            deptCompanyId: returnData.department.DeptCompanyId,            
            selectableYn: returnData.department.SelectableYn,
            level: returnData.department.Level,
            type: 'D',
          };

          emit('add-child', newDepartment);
          isOpen.value = true;
          showHideNewDeptPopup(false);
        }
      } catch (error) {
        console.error(`Error Dept Add: ${error}`);
      }
    };

    const deleteItem = async () => {
      try {
        const response = await apiClient.post("/api/Department/depart-del", {
          DeptId: props.department.deptId,
          LoginUserId: localStorage.getItem("userid"),
        });

        if (response.status === 200) {
          emit('delete-department', props.department);
        }
      } catch (error) {
        console.error(`Error Dept Delete: ${error}`);
      }
    };

    const showActions = () => {
      actionsVisible.value = true;
    };

    const hideActions = () => {
      actionsVisible.value = false;
    };

    return {
      isEditing,
      editName,
      isOpen,
      hasChildren,
      toggle,
      editItem,
      saveEdit,
      addItem,
      deleteItem,
      actionsVisible,
      showActions,
      hideActions,
      parentDepartName,
      newDepartName,
      selectableYn, 
      editDepartName,
      showNewDeptPopup,
      showEditDeptPopup,
      showHideNewDeptPopup,
      showHideEditDeptPopup,
    };
  },
  methods: {    
    selectSelectableYn(type) {
      this.selectableYn = type;
    },
  }
};
</script>

<style scoped>
.tree-item {
  list-style-type: none;
  margin: 5px 0;
  padding-left: 20px;
  position: relative;
}

.tree-item-content {
  display: flex;
  align-items: center;
  padding: 5px 10px;
  background-color: transparent;
  border-radius: 4px;
  transition: background-color 0.2s ease-in-out;
}

.tree-item-content:hover {
  background-color: #e3e3e3;
}

.tree-item-content span {
  margin-right: 10px;
}

.toggle-icon {
  margin-right: 10px;
  cursor: pointer;
}

.tree-item-actions {
  display: flex;
  gap: 5px;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}

.tree-item-actions.show {
  opacity: 1;
}

.tree-icon {
  cursor: pointer;
  width: 16px;
  height: 16px;
  transition: opacity 0.2s ease-in-out;
}

.tree-icon:hover {
  opacity: 0.7;
}

.tree-children {
  padding-left: 20px;
  margin-top: 5px;
}

input[type="text"] {
  font-size: 14px;
  padding: 2px 4px;
  border: 1px solid #ccc;
  border-radius: 3px;
  width: 100%;
}

.d_pop1 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 배경 어둡게 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* 다른 요소보다 위에 위치 */
}

.d_pop1 .d_pop_box {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 500px;
  height: auto;
  filter: drop-shadow(0 0 15px rgba(0, 0, 0, 0.2));
  background: var(--backgroundColor);
  border-radius: 8px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
}

.d_pop1 .d_pop_top {
  display: flex;
  justify-content: space-between;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 30px;
  align-content: center;
}

.d_pop1 .d_pop_top .description {
  font-size: 15px;
  margin-top: 12px;
}

.d_pop1 .d_pop_top a {
  color: var(--black);
}

.d_pop1 .d_pop_middle {
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  /* margin: 30px 0; */
  font-size: 15px;
  margin-bottom: 40px;
}

.d_pop1 .d_pop_middle th {
  font-size: 0.9em;
  line-height: 22px;
  color: var(--firstColor);
}
.d_pop1 .tbl_search table {
  margin-bottom: 0;
}
</style>
